import { AutomaticDetailsDTO, DriverDetailsType, DriverDTO, UserDriverDetailsDTO } from '@luminovo/api-contracts';
import { assertUnreachable } from '@luminovo/commons';

const selectAutomaticDetailsFromDriverType = (driver: UserDriverDetailsDTO) => {
    const driverType = driver.details.type;
    switch (driverType) {
        case DriverDetailsType.Automatic:
            return driver.details.automatic_details;
        case DriverDetailsType.Manual:
            return undefined;
        default:
            assertUnreachable(driverType);
    }
};

export const selectDriverAutomaticDetails = (driver: DriverDTO): AutomaticDetailsDTO | undefined => {
    const type = driver.type;
    switch (type) {
        case 'User':
            return selectAutomaticDetailsFromDriverType(driver.data);
        case 'System':
            return undefined;
        default:
            assertUnreachable(type);
    }
};
